/**
 * Log errors to the console in JSON format, so they get picked up by datadog
 */
export const logToDataDog = (objectToLog: object | Array<unknown>) => {
  console.error(JSON.stringify(objectToLog));
};
